import React, { useState, useEffect } from 'react';
import axios from 'axios';

import logoSvg from './assets/logo.svg';

function Logo() {
    const [logoContent, setLogoContent] = useState(null);

    useEffect(() => {
        axios.get(logoSvg)
            .then((response) => {
                setLogoContent(response.data);
            })
            .catch((error) => {
                console.error('Error loading logo SVG:', error);
            });
    }, []);

    if (!logoContent) {
        return null;
    }

    return (
        <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoContent }} />
    );
}

export default Logo;